module.exports = __webpack_public_path__ + "img/00 banner.5f8beaba.png";